import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AnalyticsRoot } from './components/AnalyticsRoot';
import { TagManagerRoot } from './components/TagManagerRoot';
import HomeRedirect from './components/HomeRedirect';
import { Index } from './pages/Index';
import { Detalle } from './pages/Detalle';
import { ConsultaUsuarioInmueble } from './pages/ConsultaUsuarioInmueble';
import { ScrollToTop } from './components/shared/ScrollToTop';

const App = () => {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <AnalyticsRoot />
      <TagManagerRoot />
      <Routes>
        <Route
          path="*"
          element={
            <HomeRedirect />
          }
        />
        <Route path="/" element={<Index />} />
        <Route path="/Detalle/:id" element={<Detalle />} />
        <Route path="/ConsultaUsuarioInmueble" element={<ConsultaUsuarioInmueble />} />
      </Routes>
    </BrowserRouter>
  );
};
export default App;
